
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Replace with your ID from the screenshot: G-ZGTQZ8HTH0
    ReactGA.initialize("G-ZGTQZ8HTH0");
  }, []);

  useEffect(() => {
    // This runs every time the URL (location) changes
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search 
    });
  }, [location]);

  return null; // This component doesn't render anything UI-related
};

export default Analytics;